import styled from "styled-components";


//nav1
export const Nav1=styled.div`
    width: 100%;
    height: 50px;
    /* border: 1px solid red; */
    background-color: black;
    color: white;
    display: flex;
    justify-content: right;
    align-items: center;
    gap: 1%;
    padding-right: 2%;
`
export const Nav1Flex=styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
`

//nav2
export const Nav2=styled.div`
    width: 100%;
    height: 120px;
    /* border: 1px solid grey; */
    display: flex;
    justify-content: space-around;
    align-items: center;
    gap: 13%;


`
// searchbar
export const SearchBar=styled.div`
    display: flex;
    border: 1px solid grey;
    align-items: center;
    border-radius: 4px;
    `
//cart
export const Cart=styled.div`
    display: flex;
    align-items: center;
    border-radius: 4px;
`

// nav3
export const Nav3=styled.div`
    width: 100%;
    height: 45px;
    /* border: 1px solid red; */
    display: flex;
    justify-content: left;
    align-items: center;
    gap: 2%;
    padding-right: 2%;
`